import {Stack, styled} from '@mui/material';

import Icon from 'presentation/icons';

const SuccessIcon = styled(Icon)`
	width: 40px;
	height: 40px;
	color: ${({theme}) => theme.colors.light.success.hue};
`;

const StyledCard = styled(Stack)`
	flex-direction: row;
	border-radius: 4px;
	justify-content: space-between;
	padding: 16px;
	width: 100%;
	background-color: ${({theme}) => theme.palette.common.white};
`;

export {SuccessIcon, StyledCard};
